import * as yup from 'yup';

export const orderGroupValidator = () =>
  yup.object({
    orderType: yup.string().nullable(),
    orderGroupId: yup.string().nullable(),
  });
